export const colors = {
  yellow: "#eab308",
  darkGrey: "#3F434A",
  lightGrey: "#F4F5F7",
  text: "#2A2D32",
  white: "#FFFFFF",
  Grey: "#87898cff",

};
